import { UseQueryOptions } from '@tanstack/react-query';

import { VoiceCallerProfile } from 'domains/content/types';
import { CuredApiPaths } from 'models/enums';

import useQuery from '../useQuery';

import QueryKeys from './keys';

type UseVoicecallerProfilesParams = {
    reactQueryOptions?: UseQueryOptions<VoiceCallerProfile[], Error>;
    type?: 'voice';
};

/**
 * Returns a react query hook containing the sender profiles data.
 * @param type - Optional 'direct-mail' string to filter sender profiles.
 * @param reactQueryOptions - Optional react-query options.
 * @returns A react query hook with sender profiles data.
 */
const useVoiceCallerProfiles = ({ reactQueryOptions, type }: UseVoicecallerProfilesParams = {}) =>
    useQuery<VoiceCallerProfile[]>(
        QueryKeys.SENDER_PROFILES(type),
        `${CuredApiPaths.SENDER_PROFILES}${type ? `/${type}` : ''}`,
        reactQueryOptions
    );

export default useVoiceCallerProfiles;
